import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PreventPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Prevent Policy
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Countering Radicalisation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="prevent" className="policy-section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Policy Information Box */}
                <div className="mb-5 p-4 shadow-sm" style={{ 
                  backgroundColor: '#f8f9fa',
                  borderRadius: '16px',
                  border: '1px solid #dee2e6'
                }}>
                  <div className="table-responsive">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057', width: '20%' }}>Lead Responsibility</td>
                          <td style={{ padding: '12px', color: '#6c757d', width: '30%' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057', width: '20%' }}>Approved by:</td>
                          <td style={{ padding: '12px', color: '#6c757d', width: '30%' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057' }}>Version</td>
                          <td style={{ padding: '12px', color: '#6c757d' }}>V6 - 2025</td>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057' }}>Date of Approval</td>
                          <td style={{ padding: '12px', color: '#6c757d' }}>1/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057' }}>Effective from</td>
                          <td style={{ padding: '12px', color: '#6c757d' }}>1/12/2025</td>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057' }}>Next review date</td>
                          <td style={{ padding: '12px', color: '#6c757d' }}>1/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '12px', color: '#6c757d' }}>ALL EMPLOYEES and FREELANCE STAFF</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#495057' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '12px', color: '#6c757d' }}>Revised Prevent Duty Guidance: for England and Wales date updated</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Main Content */}
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  
                  {/* Section 1: Introduction */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      1. INTRODUCTION
                    </h3>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Section 26 of the Revised Prevent Duty Guidance for England and Wales (2021) imposes a duty on "specified authorities", when exercising their functions, to have due regard to the need to prevent people from being drawn into terrorism. Further / Higher Education providers are "specified authorities".
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      It is a condition of funding that all further / higher education and independent training providers must comply with relevant legislation and any statutory responsibilities associated with the delivery of education and safeguarding of learners.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      "The aim of the Prevent Duty is to reduce the threat to the UK from terrorism by stopping people becoming terrorists or supporting terrorism". Terrorist groups often draw on extremist ideology, developed by extremist organisations. "The Government has defined extremism in the Prevent strategy as: "vocal or active opposition to fundamental British values, including democracy, the rule of law, individual liberty and mutual respect and tolerance of different faiths and beliefs. We also include in our definition of extremism calls for the death of members of our armed forces".
                    </p>
                  </div>

                  {/* Section 2: Safeguarding and the Prevent Duty */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      2. Safeguarding and the Prevent Duty
                    </h3>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      The document 'Keeping children safe in education' identifies radicalisation as a safeguarding concern. It is important that as part of Safeguarding, all learners, regardless of age are protected from radicalisation. DTK recognises that members of staff and learners have a role to play in preventing radicalisation. All complaints, allegations or suspicions relating to radicalisation must be taken seriously and discussed with the Designated Safeguarding Lead.
                    </p>
                  </div>

                  {/* Section 3: Definition of radicalisation */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      3. Definition of radicalisation
                    </h3>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      Radicalisation is the process where someone has their vulnerabilities or susceptibilities exploited towards crime or terrorism – most often by a third party, who have their own agenda. Concerns related to radicalisation where there are concerns that a learner is being radicalised or where there are concerns that a learner is expressing extremist views, then in line with the government Prevent Duty guidance, these concerns must be raised in the same way that any other safeguarding concern would be raised. The member of staff with the concern should discuss their concerns with the Designated Safeguarding Lead. If it is considered that the information given indicates that the learner may be at risk of radicalisation, they will make a referral in line with the Prevent Duty guidelines.
                    </p>
                  </div>

                  {/* Section 4: People responsible for Safeguarding and Prevent */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      4. People responsible for Safeguarding and Prevent
                    </h3>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      DTK recognises that all members of staff and learners have a role to play in safeguarding the welfare of young people and adults and preventing their abuse. DTK has an identified Designated Safeguarding Lead and a Deputy Designated Safeguarding Lead. A list of names, titles and contact details for these staff is attached at Appendix 1.
                    </p>
                  </div>

                  {/* Section 5: Reporting concerns */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      5. Reporting concerns
                    </h3>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Where staff have concerns about a learner or learners who may be displaying or demonstrating behaviours which could be linked to radicalisation, then these concerns must be reported to the Designated Safeguarding Lead or Deputy Designated Safeguarding Lead as soon as possible and within 2 hours.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      The standard DTK Safeguarding form should be used to record the information.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The names and contact details of managers and officers who have responsibility for safeguarding issues at DTK are included in Appendix 1.
                    </p>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>Discuss your concern with the Designated Safeguarding Lead or Deputy Designated Safeguarding Lead as soon as possible and within 2 hours.</li>
                      <li style={{ marginBottom: '10px' }}>If none of the above are available, contact DTK Directors for further guidance.</li>
                      <li style={{ marginBottom: '10px' }}>Where a student has been found to be at physical risk on DTK premises or at their place of Employment (Apprenticeships), the Health and Safety Officer should be informed immediately, but in any event, within 2 hours.</li>
                      <li style={{ marginBottom: '10px' }}>If a student is in immediate danger or at risk of serious harm, for example in a life-threatening situation, call the emergency services by dialing 999 or the Newham Prevent Team 101. You must then communicate the information to the appropriate manager/s at DTK (see appendix 1)</li>
                      <li>A flowchart describing this referral process is attached at Appendix 2.</li>
                    </ul>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      At no point should DTK staff undertake any investigatory interviews.
                    </p>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>Written Records - The Designated Safeguarding Lead shall retain a copy of:</li>
                      <li style={{ marginBottom: '10px' }}>The report to <a href="https://www.newham.gov.uk/health-adult-social-care/safeguarding" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'underline' }}>Safeguarding Adults Board (SAB) – Safeguarding Adults Board – Newham Council</a></li>
                      <li style={{ marginBottom: '10px' }}>Any notes, memoranda or correspondence dealing with the matter</li>
                      <li style={{ marginBottom: '10px' }}>Any other relevant material</li>
                      <li style={{ marginBottom: '10px' }}>Copies of reports, notes etc. should be kept securely always locked, and kept for a period of 7 years.</li>
                    </ul>
                  </div>

                  {/* Section 6: Allegations about a Member of Staff */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      6. Allegations about a Member of Staff
                    </h3>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600', backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '8px' }}>
                      At no point should DTK staff undertake any investigatory interviews.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The following procedures must be applied where allegations relating to the radicalisation of a member of staff are received.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      There are several sources from which a concern or an allegation might arise, including from:
                    </p>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li>A young person or adult</li>
                      <li>A parent / guardian / carer</li>
                      <li>A member of the public</li>
                      <li>A disciplinary investigation</li>
                      <li>Another member of staff</li>
                    </ul>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      The person to whom an allegation or concern is reported must not question or investigate the matter further, they must:
                    </p>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>Treat the matter seriously.</li>
                      <li style={{ marginBottom: '10px' }}>Keep an open mind and avoid asking leading questions (use phrases such as "Tell me, Explain to me, Describe to me)</li>
                      <li style={{ marginBottom: '10px' }}>Make a written record of the information as soon as possible (where possible in the individual's own words), which should include:
                        <ul style={{ paddingLeft: '30px', marginTop: '10px' }}>
                          <li>the name of the complainant</li>
                          <li>when and where the alleged incident took place, including date and time</li>
                          <li>who was present</li>
                          <li>the account of what is alleged to have happened</li>
                          <li>your name, signature, and date</li>
                          <li>learner's signature if appropriate</li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  {/* Initial action by the Designated Safeguarding Lead */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px' }}>
                      The standard DTK Safeguarding form should be used to record the information.
                    </h4>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>Contact the Designated Safeguarding Lead or Deputy Designated Safeguarding Lead as soon as possible and within 2 hours.</li>
                      <li>If none of the above are available, contact DTK Directors for further guidance.</li>
                    </ul>

                    <h5 style={{ color: '#7B3F9E', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px', marginTop: '25px' }}>
                      Initial action by the Designated Safeguarding Lead
                    </h5>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The Designated Safeguarding Lead must report an allegation to the Prevent Team at Newham Police.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      If a concern or an allegation requiring immediate attention is received outside normal office hours the Designated Safeguarding Lead must consult immediately with the local Prevent Team.
                    </p>

                    <h5 style={{ color: '#7B3F9E', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px', marginTop: '25px' }}>
                      Malicious Allegations
                    </h5>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Where it is subsequently found that an allegation was made with malice aforethought, the Directors will determine an appropriate course of action. This may include disciplinary action against the accuser, acceptance of a written apology (subject to agreement about future behaviour) or other such sanctions as are deemed appropriate.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      Proportionate responses to perpetrators of false or unsubstantiated allegations
                    </p>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>Despite the distress caused, learners who make false allegations may still be entitled to continue to receive full access to the curriculum</li>
                      <li style={{ marginBottom: '10px' }}>Where remaining in the same organisation as the falsely accused member of staff would be prejudicial either to that member of staff or the learner, consideration should be given to supporting the learner to identify suitable education or training opportunities elsewhere</li>
                      <li>Permanent exclusion should be considered only as a last resort</li>
                    </ul>
                  </div>

                  {/* Appendix 1 */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      Appendix 1
                    </h3>
                    <h4 style={{ color: '#495057', fontSize: '1.3rem', fontWeight: '600', marginBottom: '20px' }}>
                      Prevent Procedure - List of Useful Names and Contact Details
                    </h4>
                    <div className="table-responsive">
                      <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' }}>
                        <thead>
                          <tr style={{ backgroundColor: '#7B3F9E', color: '#fff' }}>
                            <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #6c757d' }}>Name</th>
                            <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #6c757d' }}>Title</th>
                            <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #6c757d' }}>Organisation</th>
                            <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #6c757d' }}>Telephone Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ padding: '15px', color: '#495057' }}>Wendy Ayodele</td>
                            <td style={{ padding: '15px', color: '#495057' }}>Designated Safeguarding Lead</td>
                            <td style={{ padding: '15px', color: '#495057' }}>DTK College</td>
                            <td style={{ padding: '15px', color: '#495057' }}>
                              0208 555 2999<br/>
                              07534 901827
                            </td>
                          </tr>
                          <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td style={{ padding: '15px', color: '#495057' }}>Akindele Bakarey</td>
                            <td style={{ padding: '15px', color: '#495057' }}>Deputy Designated Safeguarding Lead</td>
                            <td style={{ padding: '15px', color: '#495057' }}>DTK College</td>
                            <td style={{ padding: '15px', color: '#495057' }}>0208 555 2999</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '15px', color: '#495057' }}>Newham Prevent Team</td>
                            <td style={{ padding: '15px', color: '#495057' }}>Newham Prevent Team</td>
                            <td style={{ padding: '15px', color: '#495057' }}>Newham Police</td>
                            <td style={{ padding: '15px', color: '#495057' }}>
                              101<br/>
                              020 3373 0440
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Appendix 2 */}
                  <div className="mb-0 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      Appendix 2 - REFERRAL FLOW CHART
                    </h3>
                    <div style={{ 
                      border: '2px solid #7B3F9E', 
                      borderRadius: '12px', 
                      padding: '30px',
                      backgroundColor: '#fff'
                    }}>
                      <div style={{ 
                        border: '2px solid #495057', 
                        padding: '20px', 
                        marginBottom: '30px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa'
                      }}>
                        <strong style={{ color: '#495057', fontSize: '1.1rem' }}>MEMBER OF STAFF HAS CONCERNS ABOUT LEARNER</strong>
                      </div>

                      <div style={{ marginBottom: '25px', padding: '20px', border: '2px solid #dee2e6', borderRadius: '8px' }}>
                        <p style={{ color: '#495057', marginBottom: '10px', lineHeight: '1.6' }}>
                          <strong>1.</strong> Member of staff discusses situation with the Designated Safeguarding Lead or Deputy Designated Safeguarding Lead as soon as possible and within 2 hours.
                        </p>
                        <p style={{ color: '#495057', marginBottom: '10px', lineHeight: '1.6' }}>
                          <strong>2.</strong> If none of the above are available contact the DTK Director for further guidance.
                        </p>
                        <p style={{ color: '#495057', marginBottom: '10px', lineHeight: '1.6' }}>
                          <strong>3.</strong> If a learner is in immediate danger or at risk of serious harm, call the emergency services by dialing 999 or The Newham Prevent Team on 101. You must then communicate this information to the appropriate manager/s in DTK (see above).
                        </p>
                        <p style={{ color: '#495057', marginBottom: 0, lineHeight: '1.6' }}>
                          <strong>4.</strong> Where a student has been found to be at physical risk on DTK premises or their Employer premises, the Health and Safety Officer should be informed immediately and certainly within 2 hours.
                        </p>
                      </div>

                      <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        <div style={{ display: 'inline-block', fontSize: '2rem', color: '#7B3F9E' }}>↓</div>
                      </div>

                      <div style={{ display: 'flex', gap: '20px', marginBottom: '25px', flexWrap: 'wrap' }}>
                        <div style={{ 
                          flex: 1, 
                          minWidth: '250px',
                          border: '2px solid #7B3F9E', 
                          padding: '20px', 
                          borderRadius: '8px',
                          textAlign: 'center'
                        }}>
                          <strong style={{ color: '#7B3F9E' }}>Designated Safeguarding Lead has concerns</strong>
                        </div>
                        <div style={{ 
                          flex: 1, 
                          minWidth: '250px',
                          border: '2px solid #7B3F9E', 
                          padding: '20px', 
                          borderRadius: '8px',
                          textAlign: 'center'
                        }}>
                          <strong style={{ color: '#7B3F9E' }}>Designated Safeguarding Lead no longer has concerns</strong>
                        </div>
                      </div>

                      <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        <div style={{ display: 'inline-block', fontSize: '2rem', color: '#7B3F9E' }}>↓</div>
                      </div>

                      <div style={{ display: 'flex', gap: '20px', marginBottom: '25px', flexWrap: 'wrap' }}>
                        <div style={{ 
                          flex: 1, 
                          minWidth: '250px',
                          border: '2px solid #495057', 
                          padding: '20px', 
                          borderRadius: '8px'
                        }}>
                          <strong style={{ color: '#495057' }}>Referral to Local Prevent Team</strong>
                        </div>
                        <div style={{ 
                          flex: 1, 
                          minWidth: '250px',
                          border: '2px solid #495057', 
                          padding: '20px', 
                          borderRadius: '8px'
                        }}>
                          <strong style={{ color: '#495057' }}>No further Prevent action, although alternative pastoral and well-being services may need to be provided</strong>
                        </div>
                      </div>

                      <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        <div style={{ display: 'inline-block', fontSize: '2rem', color: '#7B3F9E' }}>↓</div>
                      </div>

                      <div style={{ marginBottom: '25px' }}>
                        <div style={{ 
                          border: '2px solid #6c757d', 
                          padding: '20px', 
                          borderRadius: '8px',
                          marginBottom: '15px'
                        }}>
                          <p style={{ color: '#495057', marginBottom: 0, fontWeight: '600' }}>
                            Local Prevent Team acknowledges receipt of referral and decides on next course of action
                          </p>
                        </div>

                        <div style={{ textAlign: 'center', margin: '15px 0' }}>
                          <div style={{ display: 'inline-block', fontSize: '2rem', color: '#7B3F9E' }}>↓</div>
                        </div>

                        <div style={{ 
                          border: '2px solid #6c757d', 
                          padding: '20px', 
                          borderRadius: '8px',
                          marginBottom: '15px'
                        }}>
                          <p style={{ color: '#495057', marginBottom: 0, fontWeight: '600' }}>
                            Feedback to referrer on next course of action
                          </p>
                        </div>
                      </div>

                      <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        <div style={{ display: 'inline-block', fontSize: '2rem', color: '#7B3F9E' }}>↓</div>
                      </div>

                      <div style={{ 
                        border: '2px solid #6c757d', 
                        padding: '20px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa'
                      }}>
                        <p style={{ color: '#495057', marginBottom: 0, fontWeight: '600' }}>
                          No further Prevent involvement at this stage, although other action may be necessary, e.g. onward referral to alternative services
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default PreventPolicy;